import React from 'react';

const SvgHn = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="HN_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="HN_svg__b" fill="#fff">
        <use xlinkHref="#HN_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        fill="#0884E6"
        mask="url(#HN_svg__b)"
        d="M0 0h28v6.667H0zM0 13.333h28V20H0z"
      />
      <path
        fill="#0E88E9"
        mask="url(#HN_svg__b)"
        d="M14 10.667l-.943.276.276-.943-.276-.943.943.276.943-.276-.276.943.276.943zM19.333 9.333l-.942.276.276-.942-.276-.943.942.276.943-.276-.276.943.276.942zM19.333 12l-.942.276.276-.943-.276-.942.942.276.943-.276-.276.942.276.943zM8.667 12l-.943.276.276-.943-.276-.942.943.276.942-.276-.276.942.276.943zM8.667 9.333l-.943.276L8 8.667l-.276-.943.943.276.942-.276-.276.943.276.942z"
      />
    </g>
  </svg>
);

export default SvgHn;
